export default __webpack_public_path__ + "/dist/images/6287738.c578c855dd22cebb4cb6f90f216d26b5.png";